define("ember-in-viewport/modifiers/in-viewport", ["exports", "@ember/debug", "@ember/object", "@ember/service", "ember-modifier", "fast-deep-equal", "@ember/destroyable"], function (_exports, _debug, _object, _service, _emberModifier, _fastDeepEqual, _destroyable) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/env",0,"ember-modifier",0,"fast-deep-equal",0,"@ember/destroyable",0,"@embroider/macros"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const WATCHED_ELEMENTS = false /* DEBUG */ ? new WeakSet() : undefined;
  let modifier;
  {
    var _class, _descriptor;
    modifier = (_class = class InViewportModifier extends _emberModifier.default {
      constructor() {
        super(...arguments);
        _initializerDefineProperty(this, "inViewport", _descriptor, this);
        _defineProperty(this, "name", 'in-viewport');
        _defineProperty(this, "lastOptions", void 0);
        _defineProperty(this, "element", null);
      }
      modify(element, positional, named) {
        this.element = element;
        this.positional = positional;
        this.named = named;
        this.validateArguments();
        if (!this.didSetup) {
          this.setupWatcher(element);
          (0, _destroyable.registerDestructor)(() => this.destroyWatcher(element));
        } else if (this.hasStaleOptions) {
          this.destroyWatcher(element);
          this.setupWatcher(element);
        }
      }
      get options() {
        // eslint-disable-next-line no-unused-vars
        const {
          onEnter,
          onExit,
          ...options
        } = this.named;
        return options;
      }
      get hasStaleOptions() {
        return !(0, _fastDeepEqual.default)(this.options, this.lastOptions);
      }
      validateArguments() {
        (false && !(this.positional.length === 0) && (0, _debug.assert)(`'{{in-viewport}}' does not accept positional parameters. Specify listeners via 'onEnter' / 'onExit'.`, this.positional.length === 0));
        (false && !(typeof this.named.onEnter === 'function' || typeof this.named.onExit === 'function') && (0, _debug.assert)(`'{{in-viewport}}' either expects 'onEnter', 'onExit' or both to be present.`, typeof this.named.onEnter === 'function' || typeof this.named.onExit === 'function'));
      }
      onEnter() {
        if (this.named.onEnter) {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          this.named.onEnter.call(null, this.element, ...args);
        }
        if (!this.options.viewportSpy) {
          this.inViewport.stopWatching(this.element);
        }
      }
      onExit() {
        if (this.named.onExit) {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          this.named.onExit.call(null, this.element, ...args);
        }
      }
      setupWatcher(element) {
        (false && !(!WATCHED_ELEMENTS.has(element)) && (0, _debug.assert)(`'${element}' is already being watched. Make sure that '{{in-viewport}}' is only used once on this element and that you are not calling 'inViewport.watchElement(element)' in other places.`, !WATCHED_ELEMENTS.has(element)));
        if (false /* DEBUG */) WATCHED_ELEMENTS.add(element);
        this.inViewport.watchElement(element, this.options, this.onEnter, this.onExit);
        this.lastOptions = this.options;
      }
      destroyWatcher(element) {
        if (false /* DEBUG */) WATCHED_ELEMENTS.delete(element);
        this.inViewport.stopWatching(element);
      }
    }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "inViewport", [_service.inject], {
      configurable: true,
      enumerable: true,
      writable: true,
      initializer: null
    }), _applyDecoratedDescriptor(_class.prototype, "onEnter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onExit", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onExit"), _class.prototype)), _class);
  }
  var _default = _exports.default = modifier;
});